<template>
  <div class="dialog-wrapper" v-if="notice && notice.uuid">
    <div class="dialog-wrapper__popup">
      <h3>{{ notice.title }}</h3>
      <p class="sub-title" v-html="notice.description" />
      <hr />
      <pre class="notice-content" v-html="notice.content" />
      <p class="catch">&#8220;건실한 상점에 안전한 투자를 연결합니다&#8221;</p>
      <button v-ripple @click="nomoreshow" class="nomoreshow-btn" type="button">다시 보지 않기</button>
      <button v-ripple @click="$emit('close')" class="confirm-btn" type="submit">확인</button>
    </div>
  </div>
</template>
<script>
import CommonUtil from '@/util/CommonUtil'
import noticeApi from '@/api/now/noticeApi'
const NOTICE_HEAD = 'fdntsns'

export default {
  props: ['isShow'],
  watch: {
    isShow(flag) {
      this.modalVisible(flag)
    }
  },
  data() {
    return {
      notice: null
    }
  },
  async created() {
    let { data } = await noticeApi.getModalNotice()
    this.notice = data[0]
    if (this.notice && !CommonUtil.isEmpty(this.notice.uuid) && CommonUtil.getCoockie(this.cookieName) == null) {
      this.$emit('show')
    }
  },
  destroyed() {
    this.modalVisible(false)
  },
  methods: {
    modalVisible(flag) {
      this.$store.commit('ui/modalVisible', flag)
    },
    nomoreshow() {
      let days = 100
      CommonUtil.setCoockie(this.cookieName, true, new Date(Date.now() + 60 * 60 * 24 * days * 1000))
      this.$emit('close')
    }
  },
  computed: {
    cookieName() {
      if (this.notice && this.notice.uuid) {
        return NOTICE_HEAD + this.notice.uuid
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wrapper {
  position: fixed;
  margin: 0;
  width: 100%;
  max-width: 42.5rem;
  height: 100%;
  z-index: 999;
  &__popup {
    text-align: center;
    width: calc(100% - 50px);
    max-width: 350px;
    margin: 0 auto;
    position: relative;
    background-color: #ffffff;
    margin-top: 0.5rem;
    padding: 30px 25px;
    min-height: 80vh;
    border-radius: 10.7px;
    animation: modal-popup-show 0.3s;

    .notice-content {
      height: 48vh;
      text-align: left;
      line-height: 25px;
      white-space: pre-line;
      overflow-y: scroll;
      padding-bottom: 20px;
      @media screen and (max-width: 350px) {
        font-size: 14px;
        line-height: 18px;
      }
      @media screen and (min-width: 350px) {
        font-size: 15px;
        line-height: 20px;
      }
    }

    h3 {
      font-size: 20px;
      font-weight: 900;
      margin-bottom: 16px;
    }

    .sub-title {
      font-size: 16px;
      font-weight: 700;
      text-align: center;
      line-height: 24px;
      color: #727d8c;
      margin-bottom: 20px;
    }

    hr {
      margin-bottom: 20px;
      height: 1px;
      background-color: #d7e1ea;
      border: none;
    }

    .catch {
      width: 100% !important;
      font-weight: 500;
      line-height: 26px;
      color: #727d8c;
      position: absolute;
      left: 0;
      bottom: 0;
      width: calc(100% - 50px);
      height: 100px;
      padding: 0 25px;
      @media screen and (max-width: 350px) {
        font-size: 12px;
        line-height: 1.2;
      }
      @media screen and (min-width: 350px) {
        font-size: 16px;
        line-height: 1.6;
      }
    }

    button {
      outline: none;
      font-size: 18px;
      font-weight: 800;
      margin: 0;
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
      padding-top: 1rem;
      padding-bottom: 1rem;
      position: absolute;
      bottom: 0;
      z-index: 3;
    }
    .nomoreshow-btn {
      color: rgb(114, 125, 140);
      background-color: rgb(215, 225, 234);
      left: 0;
      width: 53.8%;
      border-bottom-right-radius: 0px;
      border-bottom-left-radius: 10.7px;
    }
    .confirm-btn {
      color: #ffffff;
      background-color: rgb(51, 51, 51);
      right: 0;
      width: 46.2%;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 10.7px;
    }
  }
}
@keyframes modal-popup-show {
  0% {
    transform: scale(0.7);
  }
  45% {
    transform: scale(1.05);
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
</style>
